export const DocFlowMappingResultTableCell = {
  Building: 'building',
  File: 'file',
  Filename: 'filename',
  Flat: 'flat',
  HasDuplicate: 'has_duplicate',
  PagesCount: 'pages_count',
  PagesRange: 'pages_range',
  Recipient: 'recipient',
  Role: 'role',
  Status: 'status',
  SuggestedRecipients: 'suggested_recipients',
  id: 'id',
}

export const DocFlowMappingResultTableFilterName = {
  Mapped: 'mapped',
  Unmapped: 'unmapped',
}

export const DOC_FLOW_MAPPING_RESULT_TABLE_TOGGLE_FILTER_NAMES = [
  DocFlowMappingResultTableFilterName.Mapped,
  DocFlowMappingResultTableFilterName.Unmapped,
]

export const DOC_FLOW_MAPPING_RESULT_TABLE_FILTER_STATE_URL = `/idwell-api/api/v3/table/filter-states/document-stapling-uploading-results/all/`

export const DOC_FLOW_MAPPING_RESULT_TABLE_CONFIG_URL = `/idwell-api/api/v3/table/tables/document-stapling-uploading-results/`

export const DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_EDIT_RECIPIENT =
  'edit_recipient'

export const DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_MAP_RECIPIENT =
  'map_recipient'

export const DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_DELETE = 'delete_item'

export const DOC_FLOW_MAPPING_RESULT_TABLE_MASS_ACTION_DELETE = 'delete'

export const DOC_FLOW_MAPPING_RESULT_TABLE_SKELETON_ROWS = 3
